import { all } from "redux-saga/effects"
import read from "./read"

export default function*() {
  while (true) {
    yield all({
      read: read(),
    })
  }
}
